<nav>
  <ul>
    <li *ngFor="let menuItem of menuItems"><a (click)="navigate(menuItem.url)"  routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"><span>{{menuItem.text}}</span><fa-icon [icon]="faAngleRight"></fa-icon></a></li>
    <li *ngIf="isAdmin"><a routerLink="/admin" routerLinkActive="active-link"><span>Admin</span><fa-icon [icon]="faAngleRight"></fa-icon></a></li>
    <li *ngIf="isHost"><a routerLink="/host" routerLinkActive="active-link"><span>Host</span><fa-icon [icon]="faAngleRight"></fa-icon></a></li>
  </ul>
</nav>
